import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getSubState } from '../../../reducers/subReducerHelpers';
import UpsellDayPicker from './UpsellDayPicker';
import UpsellTimePicker from './UpsellTimePicker';
import Button from '../../../../shared/Button';
import { getEventSeriesChildListing, getEventTimes } from '../../series/actions/event-series'
import KioskableComponent from '../../kiosk/KioskableComponent';
import Translation from '@s/Translation';
import InventoryItemsContainer from 'checkout/views/ticket-picker/containers/InventoryItemsContainer';

/**
 * TODO translate
 */
class UpsellDateTimePicker extends KioskableComponent {

    state = {
        loadingTimes: false,
    }

    onDayPick = async dateString => {
        this.setState({loadingTimes: true});
        try {
            await this.props.getEventTimes(this.props.event.event_id, dateString, this.props.upsellId, this.props.reducerKey);
        } catch (err) {
            console.error(err);
        }
        this.setState({loadingTimes: false});
    }

    renderDayPicker = () => {
        return (
            <UpsellDayPicker
                event={this.props.event}
                reducerKey={this.props.reducerKey}
                onDayPick={this.onDayPick}
            />
        );
    }

    renderTimePicker = () => {
        return (
            <UpsellTimePicker
                isKiosk={this.isKiosk()}
                reducerKey={this.props.reducerKey}
                loading={this.state.loadingTimes}
                onLoadChildEvent={this.props.onLoadChildEvent}
            />
        );
    }

    renderOnline() {
        return (
            <div>
                {this.renderDayPicker()}
                {!!this.props.selectedDate && this.renderTimePicker()}
                {!!this.props.selectedChildEvent && (
                    <div className="upsell-embedded__action">
                        <Button onClick={() => {this.props.onLoadChildEvent(this.props.selectedChildEvent)}} className="button--primary" loading={this.props.loadingChildEvent}>
                            <Translation>{'checkout__continue'}</Translation>
                        </Button>
                    </div>
                )}
            </div>
        );
    }

    renderKiosk = () => {
        return (
            <div className="kiosk__upsell__series-picker">
                {!this.props.selectedDate && this.renderDayPicker()}
                {!!this.props.selectedDate && this.renderTimePicker()}
            </div>
        );
    }
};

const mapStateToProps = (state, ownProps) => {
    const eventSeriesState = getSubState(state.eventSeries, ownProps.reducerKey);
    return {
        selectedDate: eventSeriesState.selectedDate,
        selectedChildEvent: eventSeriesState.selectedChildEvent,
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        getEventSeriesChildListing,
        getEventTimes,
    }, dispatch);
};

UpsellDateTimePicker.propTypes = {
    event: PropTypes.object.isRequired,
    reducerKey: PropTypes.string.isRequired,
    upsellId: PropTypes.number.isRequired,
    onLoadChildEvent: PropTypes.func.isRequired,
    loadingChildEvent: PropTypes.bool.isRequired,
    isKiosk: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(UpsellDateTimePicker);
